import { render, staticRenderFns } from "./welcomePage.vue?vue&type=template&id=728a5e75&scoped=true"
import script from "./welcomePage.vue?vue&type=script&lang=js"
export * from "./welcomePage.vue?vue&type=script&lang=js"
import style0 from "./welcomePage.vue?vue&type=style&index=0&id=728a5e75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728a5e75",
  null
  
)

export default component.exports